<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="carrera-plan-modulo" titulo="Modularización / Coordinación Académica" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
  <div class="column is-1 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="overflow:auto; height: 86vh;" [style.width.px]="width-268">
          <a id="catalogos" (click)="ctrl.cargarCatalogo('carreras_planes', 'carrera-plan', 'pasarValueCarreraPlan'); ctrl.cargarCatalogo('modalidades', 'modalidad', 'pasarValueModalidad');"></a>
          <a id="pasarValueCarreraPlan" (click)="pasarValueCarreraPlan(ctrl.carreras_planes)"></a>
          <a id="pasarValueModalidad" (click)="pasarValueModalidad(ctrl.modalidades)"></a>

          <div class="field is-grouped is-fullwidth" *ngIf="tieneid == '' ? true : false">
            <div class="select">
              <select class="select" [ngClass]="{'is-danger': ctrl.dato.get('carreras_planes_id').hasError('required')}"
                (change)="nuevaCarreraPlanModulo()" name="carreras_planes_id" formControlName="carreras_planes_id" >
                <option selected value="">SELECCIONE</option>
                <option *ngFor="let val of ctrl.carreras_planes" value="{{val.id}}">{{ val.text }}</option>
              </select>
            </div>
          </div>

          <div class="field is-grouped is-fullwidth" *ngIf="tieneid != '' ? true : false">
            <span class="input">{{ctrl.dato.get('carreras_planes').value.carreras.nombre}} - {{ctrl.dato.get('carreras_planes').value.planes_estudios.nombre}}</span>
          </div>

          <div class="tabs is-boxed">
            <ul *ngIf="ctrl.dato.get('modalidades').length > 0">
              <li *ngFor="let item of ctrl.dato.controls.modalidades.controls; let i=index" [ngClass]="{ 'is-active' : tab == i}">
                <a (click)="tab=i">
                  <span class="icon">
                    <i class="fa fa-file"></i>
                  </span>
                  <span class="is-hidden-touch">
                    {{item.value.nombre}} &nbsp;
                    <!-- <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.modalidades, i)">
                                        <i class="fa fa-trash-o"></i>
                                      </button> -->
                  </span>
                </a>
              </li>
            </ul>
          </div>

          <div formArrayName="modalidades">
            <div *ngFor="let modalidad of ctrl.dato.controls.modalidades.controls; let i=index" [ngClass]="{ 'is-hidden': tab != i}">
              <div [formGroupName]="i">
                <div formArrayName="niveles">
                  <table class="table is-striped  is-fullwidth" *ngIf="modalidad.get('niveles').length > 0">
                    <thead>
                      <tr>
                        <th>Nivel</th>
                        <th>No. de módulos </th>
                        <th>Mínimo aprobatorio</th>
                        <th>Máximo aprobatorio</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let nivel of modalidad.controls.niveles.controls; let m=index" [formGroupName]="m">
                        <!-- <td>{{ m + 1 }}</td> -->
                        <td>
                          <p class="control has-icons-left has-icons-right">
                            <input class="input" type="number" readonly placeholder="Nivel" formControlName="nivel">
                            <!-- <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.nivel.valid">Este campo es requerido.</span> -->
                          </p>
                        </td>
                        <td>
                          <p class="control has-icons-left has-icons-right">
                            <input class="input" type="number" placeholder="No. de módulos" formControlName="modulos">
                            <span class="help is-danger" *ngIf="!modalidad.controls.niveles.controls[m].controls.modulos.valid">Este
                              campo es requerido.</span>
                          </p>
                        </td>
                        <td>
                          <p class="control has-icons-left has-icons-right">
                            <input class="input" type="number" placeholder="Mínimo aprobatorio" formControlName="minimo_aprobatorio">
                            <span class="help is-danger" *ngIf="!modalidad.controls.niveles.controls[m].controls.minimo_aprobatorio.valid">Este
                              campo es requerido.</span>
                          </p>
                        </td>
                        <td>
                          <p class="control has-icons-left has-icons-right">
                            <input class="input" type="number" placeholder="Máximo aprobatorio" formControlName="maximo_aprobatorio">
                            <span class="help is-danger" *ngIf="!modalidad.controls.niveles.controls[m].controls.maximo_aprobatorio.valid">Este
                              campo es requerido.</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div style="background: rgba(220, 187, 42, 0.609); width:100%; padding: 10px; margin-top: 20px;">
                                  <button type="button" class="button is-default" (click)="agregar_materia(i)">
                                    <i class="fa fa-plus"></i> Agregar Materia
                                  </button>
                                </div> -->
              </div>
            </div>
          </div>

        </section>

      </form>
    </div>
  </div>
</div>
